import { oc } from '@orpc/contract';
import { listVehiclesInputSchema, listVehiclesOutputSchema } from '../schemas/vehicles.schemas.js';
/** Only vehicles CTA has purchased appear here; inventory starts at a confirmed purchase (plan §3.1). */
export const listVehiclesContract = oc
    .route({
    method: 'GET',
    path: '/vehicles',
    tags: ['Vehicles'],
    summary: 'List the purchased vehicles of the caller’s tenant',
})
    .input(listVehiclesInputSchema)
    .output(listVehiclesOutputSchema);
//# sourceMappingURL=list-vehicles.contract.js.map